var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$options.aboutUrl)?_c('div',{staticClass:"top-nav u-flex"},[_c('a',{attrs:{"href":_vm.$options.aboutUrl}},[_vm._v(_vm._s(_vm.$options.aboutText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }